import React, { Suspense, useState, useCallback } from 'react'
import { Container, Content } from 'rsuite'
import { Outlet } from 'react-router'
import { Header, Footer, SideNav, AccountInactiveModal } from '../shared'
import { SectionLoader } from '../shared/atoms/sectionLoader/SectionLoader'

const AuthLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const toggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev)
  }, [])

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false)
  }, [])

  return (
    <Container className="layout">
      <Header onMenuToggle={toggleSidebar} />
      <Container>
        <SideNav mobileOpen={sidebarOpen} onClose={closeSidebar} />
        <Content className="content">
          <Suspense fallback={<SectionLoader />}>
            <Outlet />
          </Suspense>
        </Content>
      </Container>
      <Footer />
      <AccountInactiveModal />
    </Container>
  )
}

export default AuthLayout
